cb.define([], function () {
  var AA_sys_billrule_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
        var self = this;
      
      viewmodel.getGridModel("rules").on("afterInsertRow",function(data) {
    		var actionRow=viewmodel.getGridModel("actions").getSelectedRows()[0];
    		data.row["action"]=actionRow["action"];
    		data.row["billnum"]=viewmodel.get("cBillNo").getValue();
      });
      
    }
  }
  try {
    module.exports = AA_sys_billrule_VM_Extend;
  } catch (error) {

  }
  return AA_sys_billrule_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_sys_billrule_VM.Extend.js